<template>
  <Button icon="pi pi-lock" class="p-button-help mr-2"
          @click="showConfirmDialog"
          v-if="isButtonVisible"
          v-tooltip.top="t('action.chiusura-pianificazione')"/>
</template>

<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import pianificazioneRestService from "@/services/PianificazioneRestService";
import {useI18n} from "vue-i18n";
import {useConfirm} from "primevue/useconfirm";
import EventService from "@/services/EventService";
import {WORKFLOW_NOTIFICATION} from "@/components/common/constants/Events";


const props = defineProps({
  viaggio: {type: Object, required: true}
});

const {t} = useI18n();
const confirm = useConfirm();

const isButtonVisible = ref(false);

onMounted(() => {
  checkButtonVisibility();
  EventService.on(WORKFLOW_NOTIFICATION, checkButtonVisibility);
})

onUnmounted(() => {
  EventService.off(WORKFLOW_NOTIFICATION, checkButtonVisibility);
})

const showConfirmDialog = () => {
  confirm.require({
    message: t('message.planning-close-confirm'),
    header: t('message.generic-confirm.header'),
    icon: 'pi pi-exclamation-triangle',
    accept: () => {
      pianificazioneRestService.chiudiPianificazione(props.viaggio.codice);
    },
    reject: () => {
    }
  });
}

const checkButtonVisibility = async () => {
  const isInParentTreeTable = props.viaggio.parent;
  if (isInParentTreeTable) {
    isButtonVisible.value = await pianificazioneRestService.isPianificazioneCloseable(props.viaggio.codice);
  }
}

</script>

<style scoped>

</style>
